import { VariantProps, cva } from 'class-variance-authority';
import clsx from 'clsx';
import NextLink from 'next/link';
import * as React from 'react';

export const linkVariants = cva(
  'flex items-center justify-center w-fit font-semibold focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:transition-none transition-colors duration-300',
  {
    variants: {
      variant: {
        primary: 'text-content-lighter bg-surface-interactive hover:bg-surface-interactive-dark',
        secondary:
          'text-content-dark hover:text-content-interactive bg-surface-white border border-stroke-light hover:border-stroke-interactive hover:bg-surface-interactive-lighter',
        tertiary: 'text-content-interactive hover:bg-surface-interactive-lighter',
        destructive: 'text-danger-dark hover:bg-danger-lighter',
      },
      size: {
        sm: 'rounded-radius-sm px-sm py-xs text-label-small gap-xs',
        lg: 'rounded-radius-md px-lg py-sm text-label-large gap-sm',
        'icon-sm': 'rounded-radius-sm p-xs text-sm gap-xs',
        'icon-lg': 'rounded-radius-md p-sm text-lg gap-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'sm',
    },
  },
);

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement>, VariantProps<typeof linkVariants> {}

export function Link({ className, children, variant, size, href, ...rest }: LinkProps) {
  const variants = React.useMemo(() => linkVariants({ variant, size }), [variant, size]);
  return (
    <NextLink href={href ?? ''} className={clsx(className, variants)} {...rest}>
      {children}
    </NextLink>
  );
}
